import React, { useEffect, useState } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { Form, Row, Col } from "react-bootstrap";
import noimage from "../../assets/img/noimage.png";
import { useLocation, useNavigate } from "react-router-dom";
import { AssetStatusChange } from "../../Actions/axios";
import { toast } from "react-toastify";
import Modal from "react-modal";
import Urlmodals from "../../Modals/Urlmodal";

const AssetEdit = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const location = useLocation();
  const [data, setData] = useState({});
  const [urlData, setUrlData] = useState({});
  const [urlmod, setUrlmod] = useState(false);
  const [feedback, setFeedback] = useState({});
  const navigate = useNavigate();
  const onChangeFunc = (e) => {
    const { name, value } = e.target;
    setUrlData({ ...urlData, [name]: value });
  };

  const assetStatusChangeFunc = async (status) => {
    let sendData = {
      assetId: data?._id,
      status,
      ...urlData,
    };
    let resp = await AssetStatusChange(sendData);
    console.log("🚀 ~ assetStatusChangeFunc ~ resp:", resp);
    if (resp?.status) {
      toast.success(resp?.message);
      navigate("/assetlist");
    }else{
      toast.error(resp?.message);
      navigate("/assetlist");
    }
  };

  const sendFeedback = async () => {};

  useEffect(() => {
    setData(location?.state);
  }, [location]);

  return (
    <>
      {urlmod && (
        <Urlmodals
          onDismiss={() => setUrlmod(false)}
          urlmod={urlmod}
          data={data}
          onChangeFunc={(e) => onChangeFunc(e)}
          onSummitFunc={assetStatusChangeFunc}
        />
      )}
      <div className="cmsedit">
        <button className="btn sitebtn mb-4" onClick={() => navigate(-1)}>
          Back
        </button>
        <h1 className="pagehead">Asset Details</h1>
        <div className="cardbox">
          <Form>
            <Row>
              {data?.application &&
                Object.keys(data?.application)?.map((val) => {
                  return (
                    <Col xs={12} sm={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                      <Form.Group>
                        <Form.Label>{val.toUpperCase()}</Form.Label>
                        <Form.Control
                          type="text"
                          value={data?.application?.[val]}
                          disabled={true}
                        />
                      </Form.Group>
                    </Col>
                  );
                })}
            </Row>
          </Form>
          {data?.status == "pending" && (
            <>
              <button
                type="button"
                onClick={() => {
                  if (data?.type == "crypto") assetStatusChangeFunc("approved");
                  else setUrlmod(true);
                }}
                // onClick={() => setUrlmod(true)}
                className="btn sitebtn py-2 px-3 mt-4"
              >
                Approve
              </button>
              <button
                type="button"
                onClick={() => assetStatusChangeFunc("rejected")}
                className="btn sitebtn py-2 px-3 mt-4 mx-2"
              >
                Reject
              </button>
              <button
                type="button"
                onClick={() =>
                  navigate("/assetfeedback", { state: { ...data } })
                }
                className="btn sitebtn py-2 px-3 mt-4 mx-2"
              >
                Send Feedback
              </button>
            </>
          )}
          {data?.status == "approved" ? (
            <button
              type="button"
              className="btn sitebtn py-2 px-3 mt-4 mx-2"
            >
              Approved
            </button>
          ) : data?.status == "rejected" ? (
            <button
              type="button"
              className="btn sitebtn py-2 px-3 mt-4 mx-2"
            >
              Rejected
            </button>
          ) : (
            data?.status == "reviewed" && (
              <button
                type="button"
                className="btn sitebtn py-2 px-3 mt-4 mx-2"
              >
                Reviewed
              </button>
            )
          )}
        </div>
      </div>
    </>
  );
};

export default AssetEdit;
